/* ============================================================
   REVIVA — Striscia "In rotazione"
   Legge i dati dei prodotti, li mescola a ogni caricamento, costruisce
   la striscia scorrevole (da destra a sinistra), trascinabile col dito/mouse,
   con freccia per avanzare. Tap su un capo → scheda rapida.
   Il clic NON scatta al rilascio di un trascinamento.
   ============================================================ */
(function () {
  'use strict';

  function shuffle(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
    }
    return arr;
  }

  function buildFrame(p) {
    var fig = document.createElement('figure');
    fig.className = 'reviva-frame';
    fig.setAttribute('role', 'button');
    fig.tabIndex = 0;
    fig.dataset.url = p.url;

    var imgWrap = document.createElement('span');
    imgWrap.className = 'reviva-frame__img';
    var img = document.createElement('img');
    img.loading = 'lazy';
    img.src = p.img;
    img.alt = p.title || '';
    imgWrap.appendChild(img);

    var cap = document.createElement('figcaption');
    var name = document.createElement('span');
    name.textContent = (p.title || '').toUpperCase();
    var price = document.createElement('b');
    price.textContent = p.price || '';
    cap.appendChild(name);
    cap.appendChild(price);

    fig.appendChild(imgWrap);
    fig.appendChild(cap);
    return fig;
  }

  function openFrame(f) {
    var url = f && f.dataset ? f.dataset.url : null;
    if (!url) return;
    if (window.RevivaQuickView && typeof window.RevivaQuickView.open === 'function') {
      window.RevivaQuickView.open(url);
    } else {
      window.location.href = url;
    }
  }

  function initStrip(section) {
    var track = section.querySelector('[data-reviva-strip-track]');
    var viewport = section.querySelector('.reviva-strip__viewport');
    var dataEl = section.querySelector('[data-reviva-strip-data]');
    var arrow = section.querySelector('[data-reviva-strip-next]');
    if (!track || !viewport || !dataEl) return;

    var products;
    try { products = JSON.parse(dataEl.textContent); } catch (e) { products = []; }
    if (!products.length) { section.hidden = true; return; }

    var max = parseInt(track.getAttribute('data-max'), 10) || 16;
    var speed = parseInt(track.getAttribute('data-speed'), 10) || 45; // px al secondo

    var pick = shuffle(products.slice()).slice(0, max);

    // Due sequenze identiche = loop perfetto
    var frag = document.createDocumentFragment();
    for (var pass = 0; pass < 2; pass++) {
      for (var i = 0; i < pick.length; i++) frag.appendChild(buildFrame(pick[i]));
    }
    track.appendChild(frag);

    // ---- marquee ----
    var x = 0, paused = false, target = null, half = 0;
    function recalc() { half = track.scrollWidth / 2; }
    window.addEventListener('resize', recalc);

    viewport.addEventListener('mouseenter', function () { paused = true; });
    viewport.addEventListener('mouseleave', function () { paused = false; });

    // trascinamento + rilevamento tocco secco
    var dragging = false, startX = 0, startPos = 0, moved = 0;
    viewport.addEventListener('pointerdown', function (e) {
      dragging = true; paused = true; target = null; moved = 0;
      startX = e.clientX; startPos = x;
      try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
    });
    viewport.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      x = startPos + (e.clientX - startX);
      moved = Math.max(moved, Math.abs(e.clientX - startX));
    });
    function end(e) {
      if (!dragging) return;
      dragging = false; paused = false;
      if (moved > 8) {
        window.__stripJustDragged = Date.now();
      } else if (e && e.type === 'pointerup') {
        var t = document.elementFromPoint(e.clientX, e.clientY);
        var f = t && t.closest ? t.closest('.reviva-frame') : null;
        if (f) openFrame(f);
      }
    }
    viewport.addEventListener('pointerup', end);
    viewport.addEventListener('pointercancel', end);

    var perFrame = speed / 60; // px per frame a ~60fps

    function frameWidth() {
      var f = track.querySelector('.reviva-frame');
      return f ? f.getBoundingClientRect().width : 220;
    }

    if (arrow) {
      arrow.addEventListener('click', function () {
        target = (target === null ? x : target) - frameWidth();
      });
    }

    function step() {
      if (half === 0) recalc();
      if (target !== null) {
        x += (target - x) * 0.12;
        if (Math.abs(target - x) < 0.5) { x = target; target = null; }
      } else if (!paused) {
        x -= perFrame;
      }
      if (half > 0) {
        while (-x >= half) { x += half; if (target !== null) target += half; }
        while (x > 0) { x -= half; if (target !== null) target -= half; }
      }
      track.style.transform = 'translateX(' + x + 'px)';
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);

    // tastiera
    track.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var f = e.target.closest ? e.target.closest('.reviva-frame') : null;
      if (f) { e.preventDefault(); openFrame(f); }
    });
  }

  function boot() {
    document.querySelectorAll('.reviva-strip').forEach(initStrip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
